module.exports = __webpack_public_path__ + "static/media/20.b4758413.png";